module.exports = __webpack_public_path__ + "static/media/flac.52f73af1.svg";